/**
 * @file lazyload.js
 *
 * lazyload機能
 */

// https://www.npmjs.com/package/lazysizes
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

lazySizes.cfg.lazyClass = 'js-lazyload';

document.addEventListener('lazybeforeunveil', (event) => {
  const backGroundImageName = event.target.getAttribute('data-bg');
  const backgroundEmpty = '/src/images/story/text-only.png';
  if (backGroundImageName) {
    event.target.style.backgroundImage = `url(${backGroundImageName})`;
  } else if (!backGroundImageName) {
    event.target.style.backgroundImage = `url(${backgroundEmpty})`;
  }
});
